<div
  class="glass-container p-6 max-w-[1600px] mx-auto space-y-6 text-slate-800 dark:text-slate-200 animate-fade-in relative min-h-[85vh]">

  <!-- Backdrop Blobs -->
  <!-- <div class="absolute top-10 left-1/4 w-80 h-80 bg-amber-400/10 dark:bg-amber-400/5 rounded-full blur-3xl -z-10 animate-pulse pointer-events-none" style="animation-duration: 8s;"></div> -->
  <div
    class="absolute bottom-20 right-1/4 w-96 h-96 bg-blue-400/10 dark:bg-blue-400/5 rounded-full blur-3xl -z-10 animate-pulse pointer-events-none"
    style="animation-duration: 12s;"></div>

  <!-- ================= Header Section ================= -->
  <div class="flex flex-col md:flex-row md:items-center justify-between gap-6 pb-2">
    <div class="space-y-1">
      <h1
        class="text-2xl md:text-3xl font-extrabold tracking-tight text-slate-900 dark:text-white flex items-center gap-3">
        <div
          class="w-10 h-10 rounded-2xl bg-amber-400/10 dark:bg-amber-400/20 flex items-center justify-center text-amber-500 shadow-[0_0_15px_rgba(251,191,36,0.3)]">
          <span class="material-icons">headset_mic</span>
        </div>
        รายการแจ้งปัญหา / ติดตามเรื่อง
      </h1>
      <p class="text-xs text-slate-500 dark:text-slate-400 font-medium pl-13">
        จัดการเคสแจ้งปัญหา บริการแก้ไขประสานงานลูกค้า (CS Cases) และตรวจสอบประวัติสถานะการดำเนินงาน
      </p>
    </div>

    <!-- Create Button -->
    <button *ngIf="canCreate" (click)="openCreate()"
      class="group flex items-center gap-2 px-5 py-2.5 bg-amber-400 hover:bg-amber-500 text-slate-900 font-black rounded-2xl text-xs shadow-md transition-all duration-300 hover:scale-[1.02] hover:shadow-amber-500/20 border-none cursor-pointer">
      <span class="material-icons text-sm transition-transform duration-300 group-hover:rotate-90">add</span>
      เปิดเคสประสานงานใหม่
    </button>
  </div>

  <!-- ================= Main Panel ================= -->
  <div class="glass-panel rounded-3xl overflow-hidden shadow-sm">

    <!-- Table Control Bar (Standard Header Grid) -->
    <div
      class="p-6 border-b border-slate-100 dark:border-slate-800/80 flex flex-col xl:flex-row xl:items-center justify-between gap-4">
      <h3 class="text-base font-bold text-slate-850 dark:text-slate-100 flex items-center gap-2">
        <span class="material-icons text-amber-500">list_alt</span>
        รายการบันทึกเคสปัญหาทั้งหมด
      </h3>

      <div class="flex flex-col md:flex-row gap-3 w-full xl:flex-1 xl:min-w-0 xl:justify-end">
        <!-- Site searchable dropdown (user-accessible sites) -->
        <div class="relative w-full md:w-[240px] shrink-0 z-40">
          <div
            class="flex items-center gap-2 px-3 bg-slate-50 dark:bg-slate-900 rounded-xl border border-slate-50 dark:border-slate-800 focus-within:bg-white dark:focus-within:bg-slate-800 focus-within:ring-2 focus-within:ring-amber-200 dark:focus-within:ring-amber-500/30 transition-all h-[46px]">
            <span class="material-icons text-slate-400 text-[18px] shrink-0">local_parking</span>
            <input type="text" [(ngModel)]="searchSiteText" (focus)="onSiteSearchFocus()" (blur)="closeSiteDropdown()"
              placeholder="ค้นหา / เลือกลาน..."
              class="w-full text-xs font-semibold outline-none border-none bg-transparent text-slate-700 dark:text-slate-200" />
            <button type="button" (click)="toggleSiteDropdown()"
              class="bg-transparent border-none outline-none cursor-pointer flex items-center shrink-0">
              <span class="material-icons text-slate-400 text-sm transition-transform duration-200"
                [class.rotate-180]="isSiteDropdownOpen">expand_more</span>
            </button>
          </div>
          <div *ngIf="isSiteDropdownOpen" (mousedown)="$event.preventDefault()"
            class="absolute top-full left-0 right-0 mt-2 z-50 bg-white/95 dark:bg-slate-800/95 backdrop-blur-md border border-slate-100 dark:border-slate-700 rounded-2xl shadow-xl py-1 max-h-56 overflow-y-auto custom-scrollbar animate-fade-in-up">
            <button type="button" (click)="selectSite({ id: null, name: 'ทั้งหมด (ตามสิทธิ์)' })"
              class="w-full text-left px-4 py-2.5 text-xs text-slate-500 hover:bg-amber-50 dark:hover:bg-slate-700/50 hover:text-amber-600 block transition-colors cursor-pointer border-none bg-transparent font-bold">
              ทั้งหมด (ตามสิทธิ์)
            </button>
            <button type="button" *ngFor="let site of filteredSites" (click)="selectSite(site)"
              class="w-full text-left px-4 py-2.5 text-xs text-slate-700 dark:text-slate-200 hover:bg-amber-50 dark:hover:bg-slate-700/50 hover:text-amber-600 dark:hover:text-amber-400 block transition-colors cursor-pointer border-none bg-transparent font-medium"
              [class.bg-amber-50]="siteId === site.id"
              [class.dark:bg-slate-700]="siteId === site.id">
              {{ site.name }}
            </button>
            <div *ngIf="filteredSites.length === 0" class="py-3 text-center text-xs text-slate-400 font-medium">
              ไม่พบลานในสิทธิ์ของคุณ
            </div>
          </div>
        </div>

        <!-- Integrated Search Bar -->
        <div
          class="flex items-center   bg-slate-50 dark:bg-slate-900 rounded-xl border border-slate-50 dark:border-slate-800 focus-within:bg-white dark:focus-within:bg-slate-800 focus-within:ring-2 focus-within:ring-amber-200 dark:focus-within:ring-amber-500/30 transition-all overflow-visible w-full md:flex-1 md:min-w-[360px] relative z-30 h-[46px]">
          <!-- Dropdown Type (Left side) -->
          <div
            class="relative min-w-[120px] shrink-0 border-r border-slate-200 dark:border-slate-700 h-full shadow rounded-l-full">
            <button (click)="toggleSearchTypeDropdown()"
              class="w-full pl-4 pr-3 h-full text-xs font-bold text-slate-600 dark:text-slate-300 flex items-center justify-between hover:text-amber-600 dark:hover:text-amber-400 hover:bg-slate-100 dark:hover:bg-slate-850 rounded-l-xl transition-all focus:outline-none border-none bg-transparent cursor-pointer">
              <span>{{ currentSearchTypeLabel }}</span>
              <span class="material-icons text-xs text-slate-400 transition-transform duration-200"
                [class.rotate-180]="isSearchTypeDropdownOpen">expand_more</span>
            </button>
            <button *ngIf="isSearchTypeDropdownOpen"
              class="fixed inset-0 cursor-default z-40 border-none bg-transparent"
              (click)="toggleSearchTypeDropdown()"></button>
            <div *ngIf="isSearchTypeDropdownOpen" (mousedown)="$event.preventDefault()"
              class="absolute top-full mt-2 left-0 w-[180px] bg-white dark:bg-slate-800 rounded-xl shadow-xl border border-slate-100 dark:border-slate-700 py-1 z-50 overflow-hidden">
              <button (click)="selectSearchType('all')"
                class="w-full text-left px-4 py-2.5 text-xs font-medium text-slate-650 dark:text-slate-350 hover:bg-slate-50 dark:hover:bg-slate-700/50 hover:text-amber-500 transition-colors flex items-center gap-2 border-none bg-transparent cursor-pointer">
                <span class="material-icons text-base text-slate-400">border_all</span>
                ทั้งหมด
              </button>
              <button (click)="selectSearchType('caseno')"
                class="w-full text-left px-4 py-2.5 text-xs font-medium text-slate-650 dark:text-slate-355 hover:bg-slate-50 dark:hover:bg-slate-700/50 hover:text-amber-500 transition-colors flex items-center gap-2 border-none bg-transparent cursor-pointer">
                <span class="material-icons text-base text-slate-400">tag</span>
                เลขที่เคส
              </button>
              <button (click)="selectSearchType('subject')"
                class="w-full text-left px-4 py-2.5 text-xs font-medium text-slate-650 dark:text-slate-355 hover:bg-slate-50 dark:hover:bg-slate-700/50 hover:text-amber-500 transition-colors flex items-center gap-2 border-none bg-transparent cursor-pointer">
                <span class="material-icons text-base text-slate-400">subject</span>
                หัวข้อแจ้งเรื่อง
              </button>
              <button (click)="selectSearchType('contactname')"
                class="w-full text-left px-4 py-2.5 text-xs font-medium text-slate-650 dark:text-slate-355 hover:bg-slate-50 dark:hover:bg-slate-700/50 hover:text-amber-500 transition-colors flex items-center gap-2 border-none bg-transparent cursor-pointer">
                <span class="material-icons text-base text-slate-400">person</span>
                ชื่อผู้ติดต่อ
              </button>
              <button (click)="selectSearchType('contactphone')"
                class="w-full text-left px-4 py-2.5 text-xs font-medium text-slate-650 dark:text-slate-355 hover:bg-slate-50 dark:hover:bg-slate-700/50 hover:text-amber-500 transition-colors flex items-center gap-2 border-none bg-transparent cursor-pointer">
                <span class="material-icons text-base text-slate-400">phone</span>
                เบอร์โทรผู้ติดต่อ
              </button>
            </div>
          </div>
          <!-- Input area -->
          <div class="relative flex-1 h-full shadow rounded-r-full mr-2">
            <span class="absolute left-3 top-1/2 -translate-y-1/2 material-icons text-slate-400 text-base">search</span>
            <input type="text" placeholder="ค้นหาข้อมูลเคส..." [(ngModel)]="searchText"
              (ngModelChange)="onSearchChange()" (keyup.enter)="onClickSearch()"
              class="w-full pl-9 pr-4 h-full bg-transparent border-none text-xs font-medium text-slate-750 dark:text-slate-200 focus:ring-0 focus:outline-none placeholder:text-slate-400 dark:placeholder:text-slate-600 ">
          </div>
          <!-- Action Search Button -->
          <button (click)="onClickSearch()"
            class="shrink-0 px-4 h-[38px] bg-amber-400 hover:bg-amber-500 text-white shadow-md font-bold rounded-xl transition-all mr-1 border-none cursor-pointer text-xs">
            ค้นหา
          </button>
        </div>

        <!-- Filter Toggle -->
        <button (click)="showTableFilters = !showTableFilters"
          class="p-2.5 bg-slate-50 dark:bg-slate-900 text-slate-500 dark:text-slate-400 rounded-xl border border-slate-200 dark:border-slate-700 hover:text-amber-500 hover:border-amber-300 transition-all flex items-center justify-center h-[46px] w-[46px] cursor-pointer"
          title="ตัวกรองเพิ่มเติม">
          <span class="material-icons">filter_list</span>
        </button>

        <!-- Refresh Button -->
        <button (click)="loadCases()"
          class="p-2.5 bg-slate-50 dark:bg-slate-900 text-slate-500 dark:text-slate-400 rounded-xl border border-slate-200 dark:border-slate-700 hover:text-amber-500 hover:border-amber-300 transition-all flex items-center justify-center h-[46px] w-[46px] cursor-pointer"
          title="รีเฟรชข้อมูล">
          <span class="material-icons">refresh</span>
        </button>
      </div>
    </div>

    <!-- Collapsible Advanced Filters panel -->
    <div *ngIf="showTableFilters"
      class="px-6 pb-6 border-b border-slate-100 dark:border-slate-750 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 animate-fade-in">

      <!-- Status filter -->
      <div class="flex flex-col gap-1.5">
        <label class="text-xs font-bold text-slate-400 uppercase tracking-wider">สถานะเคส</label>
        <div
          class="flex items-center border border-slate-200/60 dark:border-slate-700/60 rounded-xl px-3 bg-slate-50 dark:bg-slate-900 h-[46px]">
          <select [(ngModel)]="status" (change)="onFilterChange()"
            class="w-full bg-transparent outline-none border-none text-xs font-medium text-slate-700 dark:text-slate-300">
            <option [ngValue]="null">ทั้งหมด (All Status)</option>
            <option value="received">รับเรื่องแล้ว</option>
            <option value="in_progress">กำลังดำเนินการ</option>
            <option value="waiting_customer">รอข้อมูลจากลูกค้า</option>
            <option value="awaiting_customer_confirm">ดำเนินการเสร็จแล้ว (เก่า)</option>
            <option value="closed">ปิดเรื่องแล้ว</option>
            <option value="cancelled">ยกเลิกแล้ว</option>
          </select>
        </div>
      </div>

      <!-- Issue Type filter -->
      <div class="flex flex-col gap-1.5">
        <label class="text-xs font-bold text-slate-400 uppercase tracking-wider">ประเภทเรื่องปัญหา</label>
        <div
          class="flex items-center border border-slate-200/60 dark:border-slate-700/60 rounded-xl px-3 bg-slate-50 dark:bg-slate-900 h-[46px]">
          <select [(ngModel)]="issueTypeId" (change)="onFilterChange()"
            class="w-full bg-transparent outline-none border-none text-xs font-medium text-slate-700 dark:text-slate-300">
            <option [ngValue]="null">ทั้งหมด (All Issue Types)</option>
            <option *ngFor="let i of issueTypes" [ngValue]="i.id">{{ i.name }}</option>
          </select>
        </div>
      </div>

      <!-- Staff Assignment filter -->
      <div class="flex flex-col gap-1.5">
        <label class="text-xs font-bold text-slate-400 uppercase tracking-wider">เจ้าหน้าที่รับผิดชอบ</label>
        <div
          class="flex items-center border border-slate-200/60 dark:border-slate-700/60 rounded-xl px-3 bg-slate-50 dark:bg-slate-900 h-[46px]">
          <select [(ngModel)]="assignedUserId" (change)="onFilterChange()"
            class="w-full bg-transparent outline-none border-none text-xs font-medium text-slate-700 dark:text-slate-300">
            <option [ngValue]="null">ทั้งหมด (All Staff)</option>
            <option *ngFor="let s of staffList" [ngValue]="s.id">{{ s.name }}</option>
          </select>
        </div>
      </div>

      <!-- Datepicker Row -->
      <div class="flex flex-col gap-1.5 md:col-span-2">
        <label class="text-xs font-bold text-slate-400 uppercase tracking-wider">ช่วงวันที่เกิดเคสเริ่มต้น</label>
        <div
          class="flex items-center border border-slate-200/60 dark:border-slate-700/60 rounded-xl px-3 bg-slate-50 dark:bg-slate-900 h-[46px] focus-within:ring-2 focus-within:ring-amber-200 dark:focus-within:ring-amber-500/30 transition-all">
          <input [matDatepicker]="startPicker" [(ngModel)]="startDate" (dateChange)="onFilterChange()"
            placeholder="เลือกวันเริ่มต้น..."
            class="w-full bg-transparent outline-none border-none py-2 text-xs font-medium text-slate-700 dark:text-slate-300" />
          <mat-datepicker-toggle matIconSuffix [for]="startPicker" class="text-amber-500"></mat-datepicker-toggle>
          <mat-datepicker #startPicker panelClass="modern-yellow-datepicker"></mat-datepicker>
        </div>
      </div>

      <div class="flex flex-col gap-1.5 md:col-span-2">
        <label class="text-xs font-bold text-slate-400 uppercase tracking-wider">ช่วงวันที่เกิดเคสสิ้นสุด</label>
        <div
          class="flex items-center border border-slate-200/60 dark:border-slate-700/60 rounded-xl px-3 bg-slate-50 dark:bg-slate-900 h-[46px] focus-within:ring-2 focus-within:ring-amber-200 dark:focus-within:ring-amber-500/30 transition-all">
          <input [matDatepicker]="endPicker" [(ngModel)]="endDate" (dateChange)="onFilterChange()"
            placeholder="เลือกวันสิ้นสุด..."
            class="w-full bg-transparent outline-none border-none py-2 text-xs font-medium text-slate-700 dark:text-slate-300" />
          <mat-datepicker-toggle matIconSuffix [for]="endPicker" class="text-amber-500"></mat-datepicker-toggle>
          <mat-datepicker #endPicker panelClass="modern-yellow-datepicker"></mat-datepicker>
        </div>
      </div>
    </div>

    <!-- Table Container -->
    <div class="overflow-x-auto custom-scrollbar">
      <table class="premium-table text-left text-sm w-full">
        <thead>
          <tr
            class="bg-slate-50/60 dark:bg-slate-800/40 text-slate-500 dark:text-slate-400 font-bold text-xs uppercase tracking-wider">

            <th class="py-4 px-5 cursor-pointer hover:bg-slate-100/50 dark:hover:bg-slate-800/50 rounded-tl-2xl w-36"
              (click)="sortData('caseNo')">
              เลขที่เรื่อง
              <span *ngIf="sortColumn === 'caseNo'" class="material-icons text-xs align-middle ml-1">
                {{ sortDirection === 'asc' ? 'arrow_upward' : 'arrow_downward' }}
              </span>
            </th>

            <th class="py-4 px-5 cursor-pointer hover:bg-slate-100/50 dark:hover:bg-slate-800/50 w-72"
              (click)="sortData('subject')">
              หัวข้อแจ้งเรื่อง
              <span *ngIf="sortColumn === 'subject'" class="material-icons text-xs align-middle ml-1">
                {{ sortDirection === 'asc' ? 'arrow_upward' : 'arrow_downward' }}
              </span>
            </th>

            <th class="py-4 px-5 cursor-pointer hover:bg-slate-100/50 dark:hover:bg-slate-800/50 text-center w-28"
              (click)="sortData('priority')">
              ความสำคัญ
              <span *ngIf="sortColumn === 'priority'" class="material-icons text-xs align-middle ml-1">
                {{ sortDirection === 'asc' ? 'arrow_upward' : 'arrow_downward' }}
              </span>
            </th>

            <th class="py-4 px-5 text-center w-24">ช่องทาง</th>

            <th class="py-4 px-5 cursor-pointer hover:bg-slate-100/50 dark:hover:bg-slate-800/50 w-44"
              (click)="sortData('siteName')">
              ลานจอด
              <span *ngIf="sortColumn === 'siteName'" class="material-icons text-xs align-middle ml-1">
                {{ sortDirection === 'asc' ? 'arrow_upward' : 'arrow_downward' }}
              </span>
            </th>

            <th class="py-4 px-5 cursor-pointer hover:bg-slate-100/50 dark:hover:bg-slate-800/50 w-44"
              (click)="sortData('assignedUserName')">
              ผู้รับผิดชอบ
              <span *ngIf="sortColumn === 'assignedUserName'" class="material-icons text-xs align-middle ml-1">
                {{ sortDirection === 'asc' ? 'arrow_upward' : 'arrow_downward' }}
              </span>
            </th>

            <th class="py-4 px-5 cursor-pointer hover:bg-slate-100/50 dark:hover:bg-slate-800/50 w-36"
              (click)="sortData('createDate')">
              วันที่แจ้งเรื่อง
              <span *ngIf="sortColumn === 'createDate'" class="material-icons text-xs align-middle ml-1">
                {{ sortDirection === 'asc' ? 'arrow_upward' : 'arrow_downward' }}
              </span>
            </th>

            <th class="py-4 px-5 text-center w-32">สถานะเคส</th>
            <th class="py-4 px-5 text-center rounded-tr-2xl w-32">ดำเนินการ</th>
          </tr>
        </thead>
        <tbody class="divide-y divide-slate-100/80 dark:divide-slate-800/80">
          <tr *ngFor="let item of cases" (click)="viewCaseDetail(item.id)"
            class="bg-white hover:bg-slate-200/40 dark:hover:bg-slate-800/60 dark:bg-slate-800/40 cursor-pointer transition-all duration-300 animate-row-fade">
            <td class="py-4 px-5 font-extrabold text-slate-900 dark:text-slate-100">{{ item.caseNo }}</td>
            <td class="py-4 px-5 font-semibold text-slate-700 dark:text-slate-300 truncate max-w-xs"
              [title]="item.subject">
              {{ item.subject }}
              <div class="text-[10px] text-slate-400 mt-0.5">ประเภท: {{ item.issueTypeName }}</div>
            </td>

            <!-- Priority badge -->
            <td class="py-4 px-5 text-center">
              <span
                [class]="'px-2.5 py-1 rounded-xl text-[10px] font-black uppercase tracking-wider ' + getPriorityColorClass(item.priority)">
                {{ getPriorityLabel(item.priority) }}
              </span>
            </td>

            <td class="py-4 px-5 text-center text-xs text-slate-500 dark:text-slate-400 font-bold">{{
              getChannelLabel(item.channel) }}</td>
            <td class="py-4 px-5 font-semibold text-slate-600 dark:text-slate-400 truncate max-w-[120px]"
              [title]="item.siteName || '-'">
              {{ item.siteName || '-' }}
            </td>
            <td class="py-4 px-5 font-bold text-slate-600 dark:text-slate-450">{{ item.assignedUserName || '-' }}</td>
            <td class="py-4 px-5 text-xs text-slate-500 dark:text-slate-400 font-bold">{{ item.createDate |
              date:'dd/MM/yyyy HH:mm' }} น.</td>

            <!-- Case status -->
            <td class="py-4 px-5 text-center">
              <span [class]="'px-3 py-1 rounded-xl text-[10px] font-bold ' + getStatusColorClass(item.status)">
                {{ getStatusLabel(item.status) }}
              </span>
            </td>

            <!-- Actions -->
            <td class="py-4 px-5 text-center" (click)="$event.stopPropagation()">
              <button (click)="viewCaseDetail(item.id)"
                class="group text-amber-500 hover:text-amber-600 dark:hover:text-amber-400 font-bold text-xs flex items-center justify-center gap-1.5 mx-auto cursor-pointer transition-all duration-300 border-none bg-transparent">
                <span class="material-icons text-sm">track_changes</span>
                <span>ติดตาม</span>
                <span
                  class="material-icons text-[10px] opacity-0 -ml-3 group-hover:opacity-100 group-hover:ml-0 transition-all duration-300">arrow_forward</span>
              </button>
            </td>
          </tr>

          <!-- Empty search state -->
          <tr *ngIf="cases.length === 0">
            <td colspan="9" class="py-16 text-center">
              <div
                class="flex flex-col items-center justify-center p-6 border-2 border-dashed border-slate-200/60 dark:border-slate-700/60 rounded-3xl bg-slate-50/30 dark:bg-slate-800/20 max-w-md mx-auto">
                <div
                  class="w-16 h-16 bg-slate-100 dark:bg-slate-800 rounded-full flex items-center justify-center mb-4 shadow-inner">
                  <span
                    class="material-icons text-4xl text-slate-300 dark:text-slate-600 animate-bounce">search_off</span>
                </div>
                <h3 class="text-sm font-extrabold text-slate-700 dark:text-slate-300 mb-1">ไม่พบข้อมูลเคสแจ้งปัญหา</h3>
                <p class="text-xs text-slate-500 dark:text-slate-400 font-medium">ลองปรับคีย์เวิร์ด
                  หรือเงื่อนไขกรองตัวเลขเคสประสานงานใหม่อีกครั้ง</p>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Standard Pagination Footer -->
    <div
      class="p-6 border-t border-slate-100 dark:border-slate-800/80 flex flex-col sm:flex-row items-center justify-between gap-4">
      <!-- Left: Item Range Info & Page Size Selection -->
      <div class="flex items-center gap-3">
        <span class="text-xs font-bold text-slate-500 dark:text-slate-400">
          แสดง {{ startItemIndex }} - {{ endItemIndex }} จาก {{ totalItems }} รายการ
        </span>

        <!-- Page Size Selection Dropdown -->
        <div class="relative">
          <button (click)="togglePageSizeDropdown()" (blur)="closePageSizeDropdown()"
            class="flex items-center gap-1.5 px-3 py-1.5 bg-white dark:bg-slate-800 border border-slate-200/80 dark:border-slate-700/80 rounded-xl text-xs font-bold text-slate-700 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-700 focus:outline-none focus:ring-1 focus:ring-amber-400 cursor-pointer transition-all shadow-sm border-none">
            <span>{{ pageSize }} / หน้า</span>
            <span class="material-icons text-slate-400 text-sm transition-transform duration-200"
              [class.rotate-180]="isPageSizeDropdownOpen">expand_more</span>
          </button>

          <div *ngIf="isPageSizeDropdownOpen" (mousedown)="$event.preventDefault()"
            class="absolute bottom-full left-0 mb-2 z-50 min-w-[5rem] bg-white/95 dark:bg-slate-850/95 backdrop-blur-md border border-slate-100 dark:border-slate-750 rounded-xl shadow-lg py-1 animate-fade-in text-center">
            <button *ngFor="let opt of pageSizeOptions" (click)="selectPageSize(opt)"
              class="w-full text-center px-3 py-2 text-xs font-bold text-slate-700 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-700/50 hover:text-amber-600 dark:hover:text-amber-400 block transition-colors cursor-pointer border-none bg-transparent">
              {{ opt }} / หน้า
            </button>
          </div>
        </div>
      </div>

      <!-- Right: Pagination Buttons -->
      <div class="flex items-center gap-1.5">
        <!-- Prev Page -->
        <button (click)="setPage(currentPage - 1)" [disabled]="currentPage === 1"
          class="w-8 h-8 rounded-xl border border-slate-200/60 dark:border-slate-700/60 bg-white dark:bg-slate-800 text-slate-400 disabled:opacity-40 hover:bg-slate-50 dark:hover:bg-slate-700 transition-colors flex items-center justify-center cursor-pointer border-none">
          <span class="material-icons text-sm">chevron_left</span>
        </button>

        <!-- Numbered Pages -->
        <ng-container *ngFor="let page of pagesArray">
          <!-- Active Page -->
          <button *ngIf="page === currentPage"
            class="w-8 h-8 rounded-xl bg-amber-400 text-slate-900 font-black shadow-[0_4px_14px_rgba(251,191,36,0.4)] flex items-center justify-center text-xs border-none">
            {{ page }}
          </button>

          <!-- Inactive Page -->
          <button *ngIf="page !== currentPage" (click)="setPage(page)"
            class="w-8 h-8 rounded-xl text-slate-600 dark:text-slate-300 font-bold hover:bg-slate-50 dark:hover:bg-slate-700 hover:text-amber-500 dark:hover:text-amber-400 transition-all flex items-center justify-center text-xs cursor-pointer border-none bg-transparent">
            {{ page }}
          </button>
        </ng-container>

        <!-- Next Page -->
        <button (click)="setPage(currentPage + 1)" [disabled]="currentPage === totalPages"
          class="w-8 h-8 rounded-xl border border-slate-200/60 dark:border-slate-700/60 bg-white dark:bg-slate-800 text-slate-400 disabled:opacity-40 hover:bg-slate-50 dark:hover:bg-slate-700 transition-colors flex items-center justify-center cursor-pointer border-none">
          <span class="material-icons text-sm">chevron_right</span>
        </button>
      </div>
    </div>

  </div>



</div>

<!-- ================= MODAL COMPONENT: Open Case ================= -->
<app-modal-customer-service-case *ngIf="isCreateModalOpen" (close)="isCreateModalOpen = false"
  (saveSuccess)="onSaved()">
</app-modal-customer-service-case>

<!-- ================= MODAL COMPONENT: Detailed Timeline view ================= -->
<app-modal-customer-service-case-detail *ngIf="isDetailModalOpen" [caseId]="selectedCaseId!"
  (close)="isDetailModalOpen = false" (saveSuccess)="onSaved()">
</app-modal-customer-service-case-detail>

<!-- ================= SHARED COMPONENT: Loading Overlay ================= -->
<app-pss-loading *ngIf="isLoading"></app-pss-loading>